<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.91234 0C6.55652 0 3.42734 1.68852 1.55956 4.42589L0.775191 3.07955C0.660086 2.88318 0.406145 2.81498 0.207975 2.92904C0.00861918 3.04192 -0.0590195 3.29473 0.0560849 3.49109L1.17272 5.40772C1.17628 5.4136 1.1834 5.41596 1.18696 5.42184C1.22137 5.47475 1.26409 5.52296 1.32342 5.55706C1.32579 5.55823 1.32817 5.55823 1.32935 5.55941C1.3875 5.59233 1.45039 5.60527 1.5121 5.6088C1.51922 5.6088 1.52515 5.61467 1.53227 5.61467H3.7679C3.99693 5.61467 4.18323 5.43007 4.18323 5.20313C4.18323 4.97619 3.99693 4.79158 3.7679 4.79158H2.31071C4.03253 2.33406 6.87098 0.823094 9.91234 0.823094C15.0173 0.823094 19.1717 4.93856 19.1717 9.99941C19.1717 15.0603 15.0173 19.1769 9.91234 19.1769C8.30326 19.1769 6.71553 18.7607 5.32241 17.9728C5.12186 17.8576 4.8703 17.927 4.75519 18.1257C4.64127 18.3232 4.71129 18.5749 4.91064 18.6878C6.42836 19.5461 8.1573 20 9.91116 20C15.4753 20 20 15.5153 20 10.0006C20.0024 4.48586 15.4765 0 9.91234 0Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconUndo",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
